import { useQuery } from '@tanstack/react-query';

import { getFeatures } from '../client';
import { useSimulationId } from './useSimulationId';

export function useDashboardData() {
  const simId = useSimulationId();

  return useQuery({
    queryKey: ['dashboardData', simId],
    queryFn: () => getFeatures({ path: { sim_id: simId }, throwOnError: true }).then(({ data }) => data),
    refetchInterval: 30_000,
  });
}
